<template>
	<el-tooltip effect="light" :content="content || '点击复制到粘贴板'" :placement="placement" :disabled="!show">
		<span v-clipboard:copy="value" v-clipboard:success="onCopy"
			v-clipboard:error="onError" @click.stop="">
			<slot>
			<i class="el-icon-document-copy view-searches"></i>
		</slot>
		</span>
	</el-tooltip>
</template>

<script>
export default {
	name: 'copySub',
	inject: ['F_alertMsg', 'F_windowLoading', 'F_getErrMSg'],
	data() {
		return {}
	},
	props: {
		value: {
			required: true
		},
		placement : {
			default : 'top-start'
		},
		show : {
			default: false
		},
		content : {}
	},
	methods: {
		onCopy: function() {
			this.F_alertMsg('复制成功', 2)
		},
		onError: function() {
			this.F_alertMsg('复制错误', 3)
		},
	},
	watch: {},
}
</script>

<style scoped>
.view-searches:hover {
	cursor: pointer;
	color: rgba(31, 168, 213, 0.7);
}
</style>
